import { LngLatLike, Map } from 'maplibre-gl';

/**
 * create custom reset button
 * @implements {object} MapLibre-GL iControl {@link https://docs.maptiler.com/sdk-js/api/controls/#icontrol} methods `onAdd`and `onRemove`
 */
export class ResetControl {
    /** reference to the map holding control */
    _map: any;
    _container: any;
    _initialState = {
        center: { lat: 0, lng: 0 },
        zoom: 0
    };
    /** method triggered, when added to the map */
    onAdd(map: Map) {
        this._map = map;
        this._initialState.center = map.getCenter();
        this._initialState.zoom = map.getZoom();

        /**  create button element */
        this._container = document.createElement('div');
        this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group custom-control';

        const button = document.createElement('button');
        const matIcon = document.createAttribute('mat-icon-button');
        button.setAttributeNode(matIcon);
        button.setAttribute('title', $localize`:@@map-resetcontrol-reset:Reset map`);

        const icon = document.createElement('span');
        icon.className = 'riege-icon material-icons';
        icon.textContent = 'restart_alt';
        button.appendChild(icon);

        button.addEventListener('click', () => {
            this._map.setZoom([this._initialState.zoom]);

            /** animate to initial position */
            const pos: LngLatLike = [this._initialState.center.lng, this._initialState.center.lat];
            this._map.easeTo({ duration: 1000, animate: true, center: pos });
        });

        this._container.appendChild(button);

        return this._container;
    }
    /** cleanup method, triggered when removed to the map */
    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}
